(function(){
       'use strict'; 
    jQuery(document).ready(function($) {
      function check_compare(value){
              for (var i = 1; i <=8; i++) {
                if (compare_list['p' + i] == value ) {
                    return true
                  break;
                } 
              }
              return false;
          }
      function readMore(string, maxWords) {       
              var strippedString = $("<p>" + string + "</p>").text().trim();      
              var array = strippedString.split(" ");
              var string = array.splice(0, maxWords).join(" ");

              if(array.length > maxWords) {
                string += "...";
              }

              return string ;
            }
      function roadtip(element) { 
              var tipText = element.html();
              element.bind('mouseover', function() {
                if (jQuery('.roadtip').length == 0) {
                  element.before('<span class="roadtip">' + tipText + '</span>');

                  var tipWidth = jQuery('.roadtip').outerWidth();
                  var tipPush = -(tipWidth / 2 - element.outerWidth() / 2);
                  jQuery('.roadtip').css('margin-left', tipPush);
                }
              });
              element.bind('mouseleave', function() { 
                jQuery('.roadtip').remove();
              });
            }
      function convert_currency(value,type){

                try{
                  var newCurrency = Currency.currentCurrency;
                }catch(ex){
                  var newCurrency = '';
                }
                try{
                  var oldCurrency = shopCurrency;
                }catch(ex){
                  var oldCurrency = '';
                }
                if(isNaN(value)){
                    value =  0.0; 
                }
 
                var cents = 0.0;
                var oldFormat = Currency.moneyFormats['USD'][ Currency.format] || '';
                var newFormat = Currency.moneyFormats[newCurrency][Currency.format] || '';
             
                if(type == 'format'){
                  return  Currency.formatMoney(value, newFormat);
                }
                if (oldFormat.indexOf('amount_no_decimals') !== -1) {
                    cents = Currency.convert(parseInt(value, 10)*100, oldCurrency, newCurrency);
                }
                else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
                    cents = Currency.convert(parseInt(value, 10)/10, oldCurrency, newCurrency);
                }
                else { 
                    cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
                }
                if(type  == 'nosymbol'){
                    return cents;
                }
                var my_data =  Currency.formatMoney(cents, newFormat);
                return my_data;
       
      }
      function get_symbol(value){
          var str = value.split("");
          var sym = '';
          for(var i=0;i<str.length;i++){
            if(isNaN(str[i])){
                sym+=str[i];
            }else{
              return sym; 
            }
          }
          return sym;
      }
      function get_price_only(price){
        var price_convert= price.toString();
        var get_currencies = 0;
        var $split = price_convert.split(';');
            if($split.length > 1){
              get_currencies = (isNaN(parseInt( price_convert.substring(1,0)))) ?  $split[1]:  $split[0];
            }else{
              get_currencies =price_convert.replace(/[^0-9.]/g, '');
            }
            get_currencies = $.trim(get_currencies); 
            var check = get_currencies.substring(1,0);
            if(isNaN((check))){
              get_currencies =   get_currencies.replace(check,'');
            }
        return parseFloat(get_currencies);

      }
      
      
      
      

        var max_price_slide = convert_currency(500000,'');
        var get_currencies = convert_currency(500000,'');
        var min_price_slide = convert_currency(1000,'');
      	var limit_product 	=	12;
      	
         
        var $split = get_currencies.split(';');
        if($split.length > 1){
           get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ?  $split[0]+';':  $split[1]+';';

        }else{
           get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ? get_symbol( get_currencies):   get_currencies.substring(1,-1);
        }

      
       $slider_filter = $('#slider-range').slider({
            range: true,
            min: 0,
            max: get_price_only(max_price_slide),
            values: [get_price_only(min_price_slide), get_price_only(max_price_slide)],
            slide: function(event, ui) {
                var max_price_slide = convert_currency(500000,'');
                var get_currencies = convert_currency(500000,'');
                var min_price_slide = convert_currency(1000,'');              
              
                var $split = get_currencies.split(';');
                if($split.length > 1){
                   get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ?  $split[0]+';':  $split[1]+';';

                }else{
                   get_currencies = (isNaN(parseInt( get_currencies.substring(1,0)))) ? get_symbol( get_currencies):   get_currencies.substring(1,-1);
                }
                var max_pr = get_currencies + ' ' + ui.values[1];
                var min_pr =  get_currencies +' ' + ui.values[0];

                $(".price_label .from").html(min_pr);
                $(".price_label .to").html(max_pr);
            },
            change: function(event, ui) {				
                var view_mode = ($(".products-change-view").hasClass('active')) ? '.products-grid-view' : '.products-list-view';
              	
                $("#loading").show(0);
              
                var max_price = ui.values[1];
                var min_price =ui.values[0];
                 
                var check = 0;
                var sum_product   = 0;
                var page = 1;
                var count=0;
              
                $("#collection-product").empty();                
                
                var html = '';
                var view =$(".products-change-view.active").data('view');
                var has_product = false;   
                //console.log(json_email);
                //console.log(json_product_tag);
              	$(".products-result-count").empty();
                $(".pagation").empty();
                $.each(json_collection_filter,function(index, elem) {
                	var current_price =  convert_currency(elem.variants[0].price,'');
                    current_price = get_price_only(current_price);
                    if (current_price <= max_price && current_price >= min_price) {                          
                      
                      has_product = true;
                      
                      html = html + json_to_html(elem,view,check,page);  
                      
                      html = html + json_to_html_grid(elem,view,check,page);                 

                      sum_product++;
                      
                      count++;
                    } 
                  
                  	if (count >= limit_product){ 
                      	page++;  
                      
                        count = 0;
                    }
                            
                    check++;
                });
                            
              	html	=	html + "<input type='hidden' id='sum_for_pagination' value='"+sum_product+"'>";
             	html	=	html + "<input type='hidden' id='limit_for_pagination' value='"+limit_product+"'>";
              	
              
                if(! has_product){
                  html +='<p class="text-center"> No products were found matching your selection.</p>';
                }
              
              
                //showing results                
                $("#collection-product").append(html);                

              	if (sum_product >= limit_product){
                  $(".products-result-count").append(" Showing 1–"+limit_product+" of "+sum_product);                  
                  $(".pagation").append(pagination_html(limit_product, sum_product));
                }
                else{
                  $(".products-result-count").append(" Showing 1–"+sum_product+" of "+sum_product);
                  
                  var view = $(".products-change-view.active").attr('data-view');                  
                  $(".product-"+view+"-filter").show();
                  $(".product-"+view+"-filter").addClass('view-'+view);
                  
                  if(view == 'grid'){
                    $(".product-list-filter").addClass('view-list');
                  }else{
                    $(".product-grid-filter").addClass('view-grid');
                  }
                }  
              
               //$(view_mode).trigger('click');

            
                $(".page-number.current").trigger('click');
              
                window.setTimeout(function() {
                     $("#loading").hide(700);
                }, 1000);
                
            } 

        }); 
      $(document).on('click','.page-number', function(event){
        
       		var val = $(this).text();        
        	var view = $(".products-change-view.active").attr('data-view'); 
       
        	$(".product-"+view+"-filter").hide();
        	$(".product-"+view+"-filter").removeClass('view-'+view);
        
        	$(".page-"+val+"-"+view).addClass('view-'+view);
        	$(".page-"+val+"-"+view).show();
        	
        	$(".page-number").removeClass("current");
                   
        	$(this).addClass("current");
        
        	var limit 	=	$("#limit_for_pagination").val();
        	var limitstart = (val - 1)*limit + 1;
        	var limitend = val*limit;        	
        	var sum 	=	$("#sum_for_pagination").val();
        	if(limitend>sum) limitend = sum;
        	$(".products-result-count").empty();
        	$(".products-result-count").append(" Showing "+limitstart+"–"+limitend+" of "+sum); 
           
      })
        function pagination_html(limit, total){
          var i;
          var sum_page = Math.ceil(total/limit);
          var $html = '';
          
           
              $html += '<ul class="page-numbers">';
                for(i=1; i<= sum_page; i++ ){
                  if(i==1) {
                    $html += '<li><a href="#primary" id="pagination_'+i+'" class="page-number current">'+i+'</a></li>';                       
                  }else{                     
                    $html += '<li><a href="#primary" id="pagination_'+i+'" class="page-number">'+i+'</a></li>';                       
                  }
                }                
              $html += '</ul>';
           
           return $html ;

        }
        function json_to_html(product,view,check,page){
         // shop-products
         var  is_sale = false;
          if (product.compare_at_price > product.price){
          	is_sale = true;
          }

         var $html = '';
          if(view=='grid'){
          	 $html += '<li class="product-item page-'+page+'-grid product-grid-filter rows-space-60 col-lg-4 col-md-4 col-sm-6 col-xs-6 col-ts-12 view-grid" style="display:none;">';
          }else{
             $html += '<li class="product-item page-'+page+'-grid product-grid-filter rows-space-60 col-lg-4 col-md-4 col-sm-6 col-xs-6 col-ts-12 view-grid" style="display:none;">';
          }
          
              $html += '<div class="product-inner">';
                $html += '<div class="product-thumb">  ';         
                  
          		if (is_sale == true){
                    $html += '<div class="status">';
                      $html += '<div class="inner">';
                        $html += '<span class="featured-flash">Hot</span>';
                      $html += '</div>';
                    $html += '</div>    ';  	
       			}
               
                  
                  var date_published = new Date(product.published_at);
                  var myDate = new Date();
           
                  var timeDiff = Math.abs(date_published.getTime() - myDate.getTime());
                  var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
          		  
          		  if (diffDays < 30){
                      $html += '<div class="status">';
                        $html += '<div class="inner">';
                          $html += '<span>New</span>';
                        $html += '</div>';
                      $html += '</div>   ';      	   
          		  }
                 
                  $html += '<div class="thumb-inner has-back-image">';
                    $html += '<a class="thumb-link" href="'+product.handle+'">';
                    if ((product.images).length > 1){          
                        $html += '<span class="back-image"><img alt="img" src="'+product.images[1] +'" alt="'+product.title+'"></span>';
                        $html += '<img  src="'+product.featured_image+'" alt="">';
                    }else{
                        $html += '<img  src="'+product.featured_image+'" alt="">';	
                    }
                    $html += '</a>';
                  $html += '</div>';
                   if (product.available == true){
                     $html += '<div class="group-buttons">';
                        $html += '<div class="inner">';
                        if ((product.variants).length> 1 ){
                            $html += '<a class="button select-option" onclick="location.href='+product.handle+'">PRODUCT OPTION</a>';
                        }else{
                          if (product.variants[0].id){
                              $html +='<a href="\'/products/'+product.handle+'\'" class="add_to_cart_button" data-pid="'+product.variants[0].id+'" title="Add to cart">ADD TO CART</a>';                             
                              
                              /*Wishlist*/	
                              if(is_customers){
                                if(jQuery.inArray(product.id, json_wishlist ) >= 0){
                                  $html +='<a class="wishlist view-added-wishlist " title="View my Wishlist" href="/collections/wishlist"><i class="ti-heart"></i></a>';
                                }else{
                                  if(json_product_tag[check].indexOf("x")>=0){
                                    $html +='<a class="wishlist " title="Add to my wishlist" href="javascript:void(0)" data-form="x'+json_product_tag[check]+'"> <i class="ti-heart"></i></a>';
                                    $html +='<a href="/collections/wishlist" class="wishlist added-wishlist"  data-toggle="tooltip" data-placement="top" ><i class="ti-heart"></i></a>';
                                  }else{
                                    $html +='<a class="wishlist " title="Add to my wishlist" href="javascript:void(0)" data-form="'+json_product_tag[check]+'"> <i class="ti-heart"></i></a>';
                                    $html +='<a href="/collections/wishlist" class="wishlist added-wishlist"  data-toggle="tooltip" data-placement="top" ><i class="ti-heart"></i></a>';
                                  }
                                }
                              }else {
                                $html += '<a class="wishlist wishlist-login"   href="javascript:void(0)" title="Login to use wishlist"><i class="ti-heart"></i></a>';
                              }
                              
                              /*Compare*/
                              var storage = $.localStorage;
                              if (storage.isSet('compare')) {
                                var compare = storage.get('compare');
                              } else {
                                storage.set('compare', {});
                              }	

                              //compare = {};
                              if ($.isEmptyObject(compare)) {
                                $html +='<a href="#" class="compare" data-pid="'+product.handle+'" title="Compare product"><span class="ti-reload"></span></a>';
                              }else{
                                var arr = $.map(compare, function(el) { return el });
                                if(jQuery.inArray(product.handle, arr ) >= 0){
                                  $html +='<a href="#" class="compare added" data-pid="'+product.handle+'" title="Compare product"><span class="ti-reload"></span></a>';
                                }else{
                                  $html +='<a href="#" class="compare" data-pid="'+product.handle+'" title="Compare product"><span class="ti-reload"></span></a>';
                                }
                              }
                            
                              $html += '<form method="post" action="/contact#contact_form" id="contact_form" class="contact-form" accept-charset="UTF-8">';
                              $html += '<input type="hidden" value="customer" name="form_type">';
                              $html += '<input type="hidden" name="utf8" value="✓">';
                              $html += '<input type="hidden" name="contact[email]" value="'+json_email[0]+'">';

                              if(json_product_tag.length > 0){
                                if(json_product_tag[check].indexOf("x")>=0){
                                  $html += '<input type="hidden" name="contact[tags]" value="x'+json_product_tag[check]+'"> ';
                                }else{
                                  $html += '<input type="hidden" name="contact[tags]" value="'+json_product_tag[check]+'"> ';
                                }
                              }else{
                                $html += '<input type="hidden" name="contact[tags]" value=""> ';
                              }
                              $html += '</form>';
                          }
                        }
                        $html += '</div>';
                      $html += '</div>';
                   }else{
                      $html += '<div class="group-buttons">';
                     	$html +='<a class="button btn-sold-out" onclick="location.href=\'/products/'+product.handle+'\'">SOLD OUT</a>';                        
                      $html += '</div>';
                   }

                $html += '</div>';
                $html += '<div class="product-info">';
                  $html += '<h4 class="product-name short"><a href="'+product.handle+'">'+product.title+'</a></h4>';
          		  if ((product.variants).length> 1 ){
                  	$html += '<span class="price"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.variants[0].price,'xx')+'">'+convert_currency(product.variants[0].price,'xx')+'</span></span>';
                  }else{
					$html += '<span class="price"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.price,'xx')+'">'+convert_currency(product.price,'xx')+'</span></span>';
                  }
                $html += '</div>';
              $html += '</div>';
            $html += '</li>';
       
          return $html ;
        }
      
        function makeid()
        {
          var text = "";
          var possible = "abcdefghijklmnopqrstuvwxyz";

          for( var i=0; i < 5; i++ )
            text += possible.charAt(Math.floor(Math.random() * possible.length));

          return text;
        }

        function json_to_html_grid(product,view,check,page){
          
          var  is_sale = false;
          if (product.compare_at_price > product.price){
          	is_sale = true;
          }

         var $html = '';
          if(view=='list'){
          	 $html += '<li class="product-item page-'+page+'-list product-list-filter list col-sm-12 rows-space-50 view-list" style="display:none;">';
          }else{
             $html += '<li class="product-item page-'+page+'-list product-list-filter list col-sm-12 rows-space-50 view-list" style="display:none;">';
          }
          	  $html += '<div class="row"> ';
    			$html += '<div class="col-ts-12 col-xs-5 col-sm-5 col-md-5 col-lg-4">	 ';
                   $html += '<div class="product-thumb">  ';         
                  
          		if (is_sale == true){
                    $html += '<div class="status">';
                      $html += '<div class="inner">';
                        $html += '<span class="featured-flash">Hot</span>';
                      $html += '</div>';
                    $html += '</div>    ';  	
       			}
               
                  
                  var date_published = new Date(product.published_at);
                  var myDate = new Date();
           
                  var timeDiff = Math.abs(date_published.getTime() - myDate.getTime());
                  var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
          		  
          		  if (diffDays < 30){
                      $html += '<div class="status">';
                        $html += '<div class="inner">';
                          $html += '<span>New</span>';
                        $html += '</div>';
                      $html += '</div>   ';      	   
          		  }
                 
                  $html += '<div class="thumb-inner has-back-image">';
                    $html += '<a class="thumb-link" href="'+product.handle+'">';
                    if ((product.images).length > 1){          
                        $html += '<span class="back-image"><img alt="img" src="'+product.images[1] +'" alt="'+product.title+'"></span>';
                        $html += '<img  src="'+product.featured_image+'" alt="">';
                    }else{
                        $html += '<img  src="'+product.featured_image+'" alt="">';	
                    }
                    $html += '</a>';
                  $html += '</div>';
           		$html += '</div>';
            $html += '</div>';
          
            $html += '<div class="col-ts-12 col-xs-7 col-sm-7 col-md-7 col-lg-8">';
              $html += '<div class="product-info">';
                $html += '<h4 class="product-name short"><a href="'+product.handle+'">'+product.title+'</a></h4>';
                 if ((product.variants).length> 1 ){
                  	$html += '<span class="price"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.variants[0].price,'xx')+'">'+convert_currency(product.variants[0].price,'xx')+'</span></span>';
                  }else{
					$html += '<span class="price"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency(product.price,'xx')+'">'+convert_currency(product.price,'xx')+'</span></span>';
                  }
                  $html += '<div class="short-descript">';
                    $html += '<p>'+product.description+'</p>';
                  $html += '</div>';
            
                   if (product.available == true){
                     $html += '<div class="group-buttons">';
                        $html += '<div class="inner">';
                        if ((product.variants).length> 1 ){
                            $html += '<a class="button select-option" onclick="location.href='+product.handle+'">PRODUCT OPTION</a>';
                        }else{
                          if (product.variants[0].id){
                              $html +='<a href="\'/products/'+product.handle+'\'" class="add_to_cart_button" data-pid="'+product.variants[0].id+'" title="Add to cart">ADD TO CART</a>';                             
                              
                              /*Wishlist*/	
                              if(is_customers){
                                if(jQuery.inArray(product.id, json_wishlist ) >= 0){
                                  $html +='<a class="wishlist view-added-wishlist " title="View my Wishlist" href="/collections/wishlist"><i class="ti-heart"></i></a>';
                                }else{
                                  if(json_product_tag[check].indexOf("x")>=0){
                                    $html +='<a class="wishlist " title="Add to my wishlist" href="javascript:void(0)" data-form="x'+json_product_tag[check]+'"> <i class="ti-heart"></i></a>';
                                    $html +='<a href="/collections/wishlist" class="wishlist added-wishlist"  data-toggle="tooltip" data-placement="top" ><i class="ti-heart"></i></a>';
                                  }else{
                                    $html +='<a class="wishlist " title="Add to my wishlist" href="javascript:void(0)" data-form="'+json_product_tag[check]+'"> <i class="ti-heart"></i></a>';
                                    $html +='<a href="/collections/wishlist" class="wishlist added-wishlist"  data-toggle="tooltip" data-placement="top" ><i class="ti-heart"></i></a>';
                                  }
                                }
                              }else {
                                $html += '<a class="wishlist wishlist-login"   href="javascript:void(0)" title="Login to use wishlist"><i class="ti-heart"></i></a>';
                              }
                              
                              /*Compare*/
                              var storage = $.localStorage;
                              if (storage.isSet('compare')) {
                                var compare = storage.get('compare');
                              } else {
                                storage.set('compare', {});
                              }	

                              //compare = {};
                              if ($.isEmptyObject(compare)) {
                                $html +='<a href="#" class="compare" data-pid="'+product.handle+'" title="Compare product"><span class="ti-reload"></span></a>';
                              }else{
                                var arr = $.map(compare, function(el) { return el });
                                if(jQuery.inArray(product.handle, arr ) >= 0){
                                  $html +='<a href="#" class="compare added" data-pid="'+product.handle+'" title="Compare product"><span class="ti-reload"></span></a>';
                                }else{
                                  $html +='<a href="#" class="compare" data-pid="'+product.handle+'" title="Compare product"><span class="ti-reload"></span></a>';
                                }
                              }
                            
                              $html += '<form method="post" action="/contact#contact_form" id="contact_form" class="contact-form" accept-charset="UTF-8">';
                              $html += '<input type="hidden" value="customer" name="form_type">';
                              $html += '<input type="hidden" name="utf8" value="✓">';
                              $html += '<input type="hidden" name="contact[email]" value="'+json_email[0]+'">';

                              if(json_product_tag.length > 0){
                                if(json_product_tag[check].indexOf("x")>=0){
                                  $html += '<input type="hidden" name="contact[tags]" value="x'+json_product_tag[check]+'"> ';
                                }else{
                                  $html += '<input type="hidden" name="contact[tags]" value="'+json_product_tag[check]+'"> ';
                                }
                              }else{
                                $html += '<input type="hidden" name="contact[tags]" value=""> ';
                              }
                              $html += '</form>';
                          }
                        }
                        $html += '</div>';
                      $html += '</div>';
                   }else{
                      $html += '<div class="group-buttons">';
                     	$html +='<a class="button btn-sold-out" onclick="location.href=\'/products/'+product.handle+'\'">SOLD OUT</a>';                        
                      $html += '</div>';
                   }

          		$html += '</div>';
          	$html += '</div>';
          $html += '</div>';
         $html += '</li>';
       
         return $html ;
       }
      
    });
})(jQuery);